import { Dialog } from "@mui/material";
import React from "react";
import DogStar from "../../assets/images/logo-cat-star.png";
import SecondaryGreenButton from "../button/SecondaryGreenButton";

export default function PopupQuestionnaireSuccessCat(props) {
  const { onClose, selectedValue, open } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <div className="pb-[36px] pt-[24px] px-[23px] rounded-[4px]">
        <p className="text-lightGreen text-[28px] text-center leading-[100%]">
          ยินดีด้วย
        </p>
        <p className="text-lightGreen text-[32px] font-medium text-center leading-[100%] mb-[10px]">
          คุณตอบคำถามครบแล้ว
        </p>
        <img
          src={DogStar}
          alt="Dog"
          style={{
            width: "60%",
            margin: "0 auto",
          }}
        ></img>
        <p className="text-darkGray text-[24px] text-center leading-[100%] mt-[15px]">
          คุณได้รับ Coin
        </p>
        <p className="text-lightGreen text-[42px] text-center leading-[100%]">
          {props.point} คะแนน
        </p>
        <div className="flex itesm-center gap-[13px] justify-center mt-[24px]">
          <SecondaryGreenButton
            variant="outlined"
            className="w-[50%]"
            onClick={() => props.actionFunction()}
          >
            ปิด
          </SecondaryGreenButton>
        </div>
      </div>
    </Dialog>
  );
}
